import { Heading,Flex } from "@chakra-ui/react";

export const PageNotFound = () => {
  return (
     <Flex align="center" justify="center" height="80vh">
         <Heading>404 | Page not found</Heading>;
     </Flex> 
  )
};
